import * as Yup from "yup";

export function initialValuesTwo(formData = {}) {
  const userData = { ...formData };

  // Asegúrate de que billAddress siempre sea un objeto
  return {
    billAddress: {
      address: userData.billAddress?.address || "", // Verifica si billAddress existe
      city: userData.billAddress?.city || "",
      postalCode: userData.billAddress?.postalCode || "",
      province: userData.billAddress?.province || "",
      country: userData.billAddress?.country || "",
    },
    iban: userData?.iban || "",
    swift: userData?.swift || "",
    taxOperation: userData?.taxOperation || "general",
    defaults: {
      dueDays: 30,
      salesTax: 21,
      salesTaxes: ["IVA 21%"],
      currency: "eur",
      language: "es",
      showTradeNameOnDocs: true,
    },
  };
}

export function validationSchemaTwo() {
  return Yup.object({
    // Valida el objeto de dirección de factura
    billAddress: Yup.object({
      address: Yup.string().required("La dirección es obligatoria"),
      city: Yup.string().required("La ciudad es obligatoria"),
      postalCode: Yup.string().required("El código postal es obligatorio"),
      province: Yup.string().required("La provincia es obligatoria"),
      country: Yup.string().required("El país es obligatorio"),
    }),

    // Validación opcional para el IBAN
    iban: Yup.string()
      .matches(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/, "El IBAN no es válido")
      .nullable() // Permite que sea null o vacío
      .notRequired(),

    // Validación opcional para el SWIFT
    swift: Yup.string()
      .matches(
        /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
        "El SWIFT no es válido",
      )
      .nullable() // Permite que sea null o vacío
      .notRequired(),
  });
}
